import React, { PropsWithChildren, HTMLAttributes } from 'react';

import clsx from 'clsx';

import { Enum } from '@utils/enum';

import { Image } from '@typings/image';

import classes from './box.module.scss';

export const backgroundColors = Enum('transparent', 'link-water');
export const boxSizes = Enum('small', 'medium', 'large');

type RawProps = {
  background?: keyof typeof backgroundColors;
  boxSize?: keyof typeof boxSizes;
  className?: string;
  backgroundImage?: Image;
  height?: number;
} & HTMLAttributes<HTMLDivElement>;

export type BoxProps = PropsWithChildren<RawProps>;

export const Box = ({
  className,
  children,
  backgroundImage,
  background,
  boxSize,
  ...divProps
}: BoxProps) => {
  const props: React.HTMLAttributes<HTMLDivElement> = {
    className: clsx(
      classes.box,
      boxSize === 'large' && classes.large,
      background === 'transparent' && classes.bgTransparent,
      background === 'link-water' && classes.bgLinkWater,
      !!backgroundImage && classes.image,
      className,
    ),
    style: {},
    ...divProps,
  };

  // IMAGE
  if (backgroundImage) {
    props.style = {
      backgroundImage: `url(${backgroundImage})`,
    };
  }

  return <div {...props}>{children}</div>;
};
